export default __webpack_public_path__ + "static/media/imagenes-03_11zon.f42c3393.webp";